import { defineStore } from 'pinia'
import { isRuContractedAnchor as queryRuContractedAnchor } from '@/services/recruit'
import { ref } from 'vue'

export const useRecruitStore = defineStore('recruit', () => {
  const isContractedAnchor = ref(false)
  const isContractedAnchorLoading = ref(false)
  const isContractedAnchorLoaded = ref(false)
  let pendingRequest: Promise<boolean> | null = null

  const fetchIsContractedAnchor = async (force = false) => {
    if (isContractedAnchorLoaded.value && !force) {
      return isContractedAnchor.value
    }

    if (pendingRequest && isContractedAnchorLoading.value) {
      return pendingRequest
    }

    isContractedAnchorLoading.value = true
    pendingRequest = queryRuContractedAnchor()
      .then(res => {
        isContractedAnchor.value = Boolean(res?.result)
        isContractedAnchorLoaded.value = true
        return isContractedAnchor.value
      })
      .catch(error => {
        console.error(error)
        isContractedAnchor.value = false
        isContractedAnchorLoaded.value = true
        return false
      })
      .finally(() => {
        isContractedAnchorLoading.value = false
        pendingRequest = null
      })

    return pendingRequest
  }

  return {
    isContractedAnchor,
    isContractedAnchorLoading,
    isContractedAnchorLoaded,
    fetchIsContractedAnchor
  }
})
